<template>
  <v-menu  offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mb-2" v-bind="attrs" v-on="on" small>
        {{ $t('contacts.btn.bulk', { count: items.length }) }}
        <v-icon class="ml-2" color="primary">mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item link @click="$emit('bulk-delete', items)">
        <v-icon class="mr-2" color="red" small>mdi-delete</v-icon>
        <v-list-item-title>{{ $t('contacts.btn.delete') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'contacts-msgs-bulk-btn',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
</style>
